/**
 * Halaman keranjang — tempat melihat dan mengubah isi belanja sebelum
 * melanjutkan ke checkout.
 *
 * Sebelumnya keranjang hanya tampil sebagai ringkasan read-only di halaman
 * checkout, jadi tidak ada cara mengubah jumlah atau membuang item.
 */

import { Link } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { CartLines } from "@/components/CartLines";
import { Button } from "@/components/ui/Button";
import { formatIDR } from "@/lib/format";

export function CartPage() {
  const { lines, subtotal, count, clear } = useCart();

  if (lines.length === 0) {
    return (
      <div className="max-w-xl mx-auto px-4 py-20 text-center">
        <h1 className="font-heading text-2xl font-bold text-ink-primary">
          Keranjang Anda kosong
        </h1>
        <p className="mt-2 font-sans text-sm text-ink-muted">
          Belum ada produk yang dipilih.
        </p>
        <Link to="/products" className="inline-block mt-6">
          <Button variant="primary">Lihat Katalog</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight text-ink-primary">
            Keranjang
          </h1>
          <p className="mt-2 font-sans text-sm text-ink-muted">
            {count} item siap dibeli.
          </p>
        </div>
        <button
          type="button"
          onClick={clear}
          className="font-sans text-xs text-ink-muted underline hover:text-hot"
        >
          Kosongkan keranjang
        </button>
      </div>

      <div className="mt-6 border border-border bg-surface rounded-lg px-5">
        <CartLines />
      </div>

      <div className="mt-6 border border-border-strong bg-surface rounded-lg p-5
                      flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-sans text-sm text-ink-muted">Subtotal</p>
          <p className="font-mono text-2xl text-accent">{formatIDR(subtotal)}</p>
          <p className="mt-1 font-sans text-xs text-ink-dim">
            Biaya layanan dihitung setelah Anda memilih metode pembayaran.
          </p>
        </div>
        <div className="flex gap-3">
          <Link to="/products">
            <Button variant="secondary">Tambah Produk</Button>
          </Link>
          <Link to="/checkout">
            <Button variant="primary">Lanjut ke Checkout →</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
